import { useTranslation } from 'react-i18next';

const ServicesSection = () => {
  const { t } = useTranslation('pharmacies');

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            {t('services.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('services.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {t('services.items', { returnObjects: true }).map((service: any, index: number) => (
            <div key={index} className="bg-gray-50 rounded-xl p-8 hover:shadow-lg transition-shadow">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className={`text-2xl text-blue-600 ${
                  index === 0 ? 'ri-money-dollar-circle-line' :
                  index === 1 ? 'ri-shield-check-line' :
                  index === 2 ? 'ri-database-2-line' :
                  index === 3 ? 'ri-file-shield-2-line' :
                  index === 4 ? 'ri-file-list-3-line' :
                  'ri-bar-chart-box-line'
                }`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;